import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";
import {  CustomTooltip, TableAbstract } from "shared/components/Components";
import { useMercuryContext } from "../../context";
import TableTitle from "../../components/table/TableTitle";
import CurrenciesType from "./CurrenciesType";
import PermissionWrapper from "shared/components/PermissionWrapper";
import DeleteCurrency from "./DeleteCurrency";
import { checkPermissions } from "../../common/utils/checkPermissions";
import GetActiveStatusIcon from "shared/components/GetActiveStatusIcon";

class ManageCurrencies extends TableAbstract<any> {
  FilterComponents = [];

  defaultSortField = "name";

  columns = [
    {
      id: "name",
      title: "Name",
      dataIndex: "name",
      sorter: true,
      width: 150,
      render: (text: string) => <CustomTooltip text={text} length={17} />,
    },
    {
      id: "symbol",
      title: "Symbol",
      dataIndex: "symbol",
      sorter: true,
      width: 200,
      render: (text: string) => <CustomTooltip text={text} length={25} />,
    },
    {
      id: "decimalCharacter",
      title: "Decimal Character",
      dataIndex: "decimalCharacter",
      sorter: true,
      width: 150,
      render: (text: string) => <CustomTooltip text={text} length={17} />,
    },
    {
      id: "separatorCharacter",
      title: "Separator Character",
      dataIndex: "separatorCharacter",
      sorter: true,
      width: 150,
      render: (text: string) => <CustomTooltip text={text} length={17} />,
    },
    {
      id: "precision",
      title: "Precision",
      dataIndex: "precision",
      sorter: true,
      width: 200,
      render: (text: string) => <CustomTooltip text={text} length={25} />,
    },
    {
      id: "displayPattern",
      title: "Display Pattern",
      dataIndex: "displayPattern",
      sorter: true,
      width: 150,
      render: (text: string) => <CustomTooltip text={text} length={17} />,
    },
    {
      id: "negativeDisplayPattern",
      title: "Negative Display Pattern",
      dataIndex: "negativeDisplayPattern",
      sorter: true,
      width: 150,
      render: (text: string) => <CustomTooltip text={text} length={17} />,
    },
    {
      id: "isActive",
      title: (<TableTitle title="Active" />) as any,
      dataIndex: "isActive",
      sorter: true,
      width: 60,
      align: "center" as any,
      render: (value: boolean | null | undefined) => <GetActiveStatusIcon status={value}/>
    }
  ];

  renderActions() {
    const selectedRows = this.state.selectedRows;
    const isExactlyOneRowSelected = selectedRows?.length === 1;

    const userPermissions = this.userContext.userDetails?.permissions || [];
    const hasEditAccess = checkPermissions(userPermissions, [
      {
        customerApplication: "Google",
        permissionName: "Currencies",
        action: "edit",
      },
    ]);

    const hasCreateAccess = checkPermissions(userPermissions, [
      {
        customerApplication: "Google",
        permissionName: "Currencies",
        action: "create",
      },
    ]);
    const hasDeleteAccess = checkPermissions(userPermissions, [
      {
        customerApplication: "Google",
        permissionName: "Currencies",
        action: "delete",
      },
    ]);

    return (
      <>
        <PermissionWrapper
          hasPermissions={hasCreateAccess}
          children={
            <CurrenciesType
              hasPermissions={hasCreateAccess}
              buttonLabel="Add"
              refresh={this.reload}
            />
          }
        />

        <PermissionWrapper
          {...(hasEditAccess && {
            tooltip:
              this.state.selectedRows.length !== 1
                ? "Select 1 row to enable edit option"
                : "",
          })}
          hasPermissions={hasEditAccess && isExactlyOneRowSelected}
        >
          <div>
            <CurrenciesType
              initialValues={selectedRows[0]}
              buttonLabel="Edit"
              refresh={this.reload}
              selectedRows={selectedRows}
              hasPermissions={hasEditAccess && isExactlyOneRowSelected}
            />
          </div>
        </PermissionWrapper>

        <PermissionWrapper
          {...(hasDeleteAccess && {
            tooltip:
              this.state.selectedRows.length !== 1
                ? "Select 1 row to enable delete option"
                : "",
          })}
          hasPermissions={
            hasDeleteAccess && isExactlyOneRowSelected
          }
        >
          <div>
            <DeleteCurrency
              selectedRows={this.state.selectedRows}
              refresh={this.reload}
              hasPermissions={hasDeleteAccess && isExactlyOneRowSelected}
            />
          </div>
        </PermissionWrapper>
      </>
    );
  }

  pageTitle = "Manage Currencies  - Mercury © RWS";
  title = "Manage Currencies";
  pageClass = "currenciesTable";

  async fetch() {

    try {

      const response = await this.userContext.coreClient.get("/core-v1/currency");

      return {data:{ documents: response.data,
         meta: {
          total: response.data.length,
          page: 1,
          pages: 1,
          match: {},
          sort: {},
          skip: 0,
          limit: 10,
        }
       }} as any;
      
    } catch (error) {
      console.error("Error fetching Currencies:", error);
      return {
        data: { documents: [] },
        meta: {
          total: 0,
          page: 1,
          pages: 0,
          match: {},
          sort: {},
          skip: 0,
          limit: 10,
        },
      };
    }
  }
}

const ManageCurrenciesTable = () => {
  const context = useMercuryContext();
  const breaks = useBreakpoint();

  return (
    <ManageCurrencies
      id="ManageCurrencies"
      context={context}
      breaks={breaks as any}
      useLegacyEndpoints={false}
      hasSidebar={true}
      hideDefaultFilters={true}
    />
  );
};

export default ManageCurrenciesTable;
